













import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import { ParticaEvent } from "../../Models/ParticaEvent";
import { CustomerArticleLicenceDTO } from "../../Generated/ParticaAPI";
import ParticaCardMax from "@/Ui-Components/Common/Container/ParticaCardMax.vue";

@Component(
	{
		name: "ViewArticleLicence",
		components: { ButtonList, ParticaCardMax }
	})
export default class ViewArticleLicence extends Vue {
	@Prop() private licence: CustomerArticleLicenceDTO;

	private eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}
}
